import { request } from './request.js'

export const getAbouts = () => request.get('abouts')
export const getAboutsById = (id) => request.get('abouts/' + id)
